export const UNLOAD_TYPE_MIN_TIMES_MAP: { [key: string]: number } = {
  DIRECT_DISCHARGE: 10,
  PUMP: 10,
  STATIC_PUMP: 20,
  'CRANE_&_SKIP': 30,
  DUMPER: 45,
  SPRAYED: 60,
  WHEELBARROW: 90,
};

export const UNLOAD_TIMES_TO_UNLOAD_TYPE_MAP: { [key: string]: number } = {
  'DT-10MI': 10,
  'DT-15MI': 15,
  'DT-20MI': 20,
  'DT-30MI': 30,
  'DT-45MI': 45,
  'DT-60MI': 60,
  'DT-90MI': 90,
  'DT-2HH': 120,
};
